import { SVGProps } from "react";

const STIPatreon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Patreon" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#052d49" /><circle cx={310} cy={223} r={113} fill="#fff" /><path fill="#f96854" d="M109 410V110h56v300" /></svg>;

export { STIPatreon };